(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initMousemoveAnimations = function () {
        var items = Array.from(document.querySelectorAll('[data-anim="mousemove"]'));
        var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var ticking = false;
        var isActive = false;
        var lastX = 0;
        var lastY = 0;
        var defaultFactors = [0.4, 0.7, 0.4];

        if (!items.length) {
            return;
        }

        function getFactor(item, index) {
            var factor = parseFloat(item.getAttribute('data-mousemove-factor'));

            if (!Number.isNaN(factor)) {
                return factor;
            }

            return defaultFactors[index] || defaultFactors[0];
        }

        function shouldRun() {
            return canHover.matches && !reduceMotion.matches && window.innerWidth > 1200;
        }

        function resetItems() {
            items.forEach(function (item) {
                item.style.transform = '';
            });
        }

        function update() {
            var width = window.innerWidth || document.documentElement.clientWidth;
            var height = window.innerHeight || document.documentElement.clientHeight;
            var moveX = (lastX / width) * 100 - 50;
            var moveY = (lastY / height) * 100 - 50;

            items.forEach(function (item, index) {
                var factor = getFactor(item, index);
                var x = moveX * factor;
                var y = moveY * factor;

                item.style.transform = 'translate3d(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px, 0)';
            });

            ticking = false;
        }

        function requestUpdate(event) {
            lastX = event.clientX;
            lastY = event.clientY;

            if (ticking) {
                return;
            }

            ticking = true;
            window.requestAnimationFrame(update);
        }

        function enable() {
            if (isActive || !shouldRun()) {
                return;
            }

            isActive = true;
            window.addEventListener('mousemove', requestUpdate, { passive: true });
        }

        function disable() {
            if (!isActive) {
                resetItems();
                return;
            }

            isActive = false;
            ticking = false;
            window.removeEventListener('mousemove', requestUpdate);
            resetItems();
        }

        function refresh() {
            if (shouldRun()) {
                enable();
            } else {
                disable();
            }
        }

        refresh();
        window.addEventListener('resize', refresh);

        if (typeof canHover.addEventListener === 'function') {
            canHover.addEventListener('change', refresh);
            reduceMotion.addEventListener('change', refresh);
        }
    };
})();
